import { createContext, useContext, useEffect, useState } from "react";
import { T } from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("pwl-lang") || "en");

  useEffect(() => {
    localStorage.setItem("pwl-lang", lang);
    document.documentElement.lang = lang === "zh" ? "zh-CN" : lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: T[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export const usePath = () => {
  const { lang } = useLanguage();
  return (path) => (lang === "en" ? path : `/${lang}${path === "/" ? "" : path}`);
};
